import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import React from 'react';
import ErrorPage from 'components/shared/ErrorPage/ErrorPage';

export const AlertsComingSoon = () => {
  return (
    <div>
      <ErrorPage summaryMessage="We're working on this feature and it will be available soon.">
        <div className="error-page-content error-page-message">
          <div>
            You can not sign up for activity alerts or change your alert
            preferences at this time. Please try again later.
          </div>
          <div className="error-page-return error-page-link">
            <Link to="/dashboard">Return to dashboard</Link>
          </div>
        </div>
      </ErrorPage>
    </div>
  );
};

const mapStateToProps = (state) => state;
export default connect(mapStateToProps)(AlertsComingSoon);
